import gql from "graphql-tag";

export const ADD_COMMENT = gql`
  mutation AddProjectComment($body: String!, $projectId: String!) {
    addProjectComment(body: $body, projectId: $projectId) {
      id
    }
  }
`;
